export default __webpack_public_path__ + "static/media/sec4contentimg2.eae9157f.png";